import Service from '@mjcloud/service';
import globalData from '@mjcloud/global-data';
import { ExceptionHelper } from '@mjcloud/exception';
import { DataExtendStoreBase } from '@mjcloud/extend-store';

export default class ModuleExtendStore extends DataExtendStoreBase {
  protected isNeedNotificationPage = true;
}
